import React, { useState, useEffect } from "react";
import "./BuffetBookingPage.css";
import buffetVideo from "../assets/buffet-video.mp4";
import { Helmet } from "react-helmet";

const SLOTS = {
  1: { label: "Slot 1 (2–4pm)", start: "14:00", end: "16:00" },
  2: { label: "Slot 2 (4:30–6:30pm)", start: "16:30", end: "18:30" },
};

// Removed the time-checking logic
const SpinnerOverlay = () => (
  <div className="spinner-overlay">
    <div className="spinner"></div>
  </div>
);

const BuffetBookingPage = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [numPeople, setNumPeople] = useState(1);
  const [slots, setSlots] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [dateError, setDateError] = useState("");

  const getNextSunday = () => {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const daysUntilSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
    const nextSunday = new Date(now);
    nextSunday.setDate(now.getDate() + daysUntilSunday);
    const yyyy = nextSunday.getFullYear();
    const mm = String(nextSunday.getMonth() + 1).padStart(2, "0");
    const dd = String(nextSunday.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const fetchSlots = async (date) => {
    try {
      const res = await fetch(
        `/php/get-slot-availability.php?booking_date=${date}`
      );
      const data = await res.json();
      if (data.success) setSlots(data.slots);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => setBookingDate(getNextSunday()), []);
  useEffect(() => {
    if (bookingDate) fetchSlots(bookingDate);
  }, [bookingDate]);

  useEffect(() => {
    if (bookingSuccess) window.scrollTo({ top: 0, behavior: "smooth" });
  }, [bookingSuccess]);

  const handleDateChange = (e) => {
    const chosen = new Date(e.target.value);
    if (chosen.getDay() !== 0) {
      setDateError("❌ Please select a Sunday.");
      return;
    }
    setDateError("");
    setBookingDate(e.target.value);
  };

  const handleBackToForm = () => {
    setBookingSuccess(false);
    setName("");
    setPhone("");
    setEmail("");
    setSelectedSlot("");
    setNumPeople(1);
    setMessage("");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const selected = slots.find((s) => s.id === parseInt(selectedSlot));
    if (selected && numPeople > selected.remaining) {
      setMessage(
        `❌ Only ${selected.remaining} ${
          selected.remaining === 1 ? "slot is" : "slots are"
        } left for this time.`
      );
      return;
    }

    setLoading(true);
    const startTime = Date.now();

    try {
      const res = await fetch("/php/book-buffet.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          phone,
          email,
          booking_date: bookingDate,
          slot_id: selectedSlot,
          num_people: numPeople,
        }),
      });

      const data = await res.json();
      const elapsed = Date.now() - startTime;
      const remainingTime = 3000 - elapsed;

      setTimeout(
        () => {
          setLoading(false);
          if (data.success) {
            const bookingDateFormatted = new Date(
              bookingDate
            ).toLocaleDateString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            });

            const slotLabel = SLOTS[selectedSlot]?.label || "";

            setMessage(
              `🎉 Your booking for ${numPeople} ${
                numPeople > 1 ? "people" : "person"
              } on ${bookingDateFormatted} (${slotLabel}) is confirmed. We can’t wait to welcome you!`
            );
            setBookingSuccess(true);
          } else {
            setMessage(data.message || "Booking failed.");
          }
        },
        remainingTime > 0 ? remainingTime : 0
      );
    } catch (err) {
      const elapsed = Date.now() - startTime;
      const remainingTime = 3000 - elapsed;
      setTimeout(
        () => {
          setLoading(false);
          setMessage("An error occurred. Please try again.");
        },
        remainingTime > 0 ? remainingTime : 0
      );
    }
  };

  return (
    <div className="page-container">
      <Helmet>
        <title>Buffet Bookings | LasGidi Restaurant</title>

        <meta
          name="description"
          content="Book your buffet experience at LasGidi Restaurant in Manchester. Enjoy an all-you-can-eat selection of authentic Nigerian dishes every Sunday."
        />

        <meta
          name="keywords"
          content="LasGidi Restaurant Buffet, Manchester Nigerian Buffet, All You Can Eat Nigerian Food, Buffet Booking Manchester, African Buffet"
        />

        <meta
          property="og:title"
          content="Buffet Bookings | LasGidi Restaurant"
        />

        <meta
          property="og:description"
          content="Reserve your spot for LasGidi Restaurant’s Sunday buffet. Authentic Nigerian meals served fresh in an all-you-can-eat experience."
        />

        <meta property="og:type" content="website" />
      </Helmet>

      <div className="booking-container heading-container">
        <h1>Book a Buffet Slot</h1>
      </div>

      <div className="buffet-layout">
        <div className="video-section">
          <video
            src={buffetVideo}
            autoPlay
            muted
            loop
            playsInline
            className="background-video blurred"
          ></video>

          <video
            src={buffetVideo}
            autoPlay
            muted
            loop
            playsInline
            controls
            className="background-video main"
          ></video>
        </div>

        <div className="buffet-right">
          <div className="buffet-booking-container">
            {loading ? (
              <SpinnerOverlay />
            ) : bookingSuccess ? (
              <div className="success-container">
                <p>{message}</p>
                <button className="post-review-btn" onClick={handleBackToForm}>
                  Back
                </button>
              </div>
            ) : (
              <>
                <p>
                  Reserve your spot for our Sunday buffet. Select your preferred
                  date & time and join us for a delightful dining experience.
                </p>

                <form className="booking-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Booking Date:</label>
                    <input
                      type="date"
                      value={bookingDate}
                      min={getNextSunday()}
                      onChange={handleDateChange}
                    />
                    {dateError && <p className="error-message">{dateError}</p>}
                  </div>

                  <div className="form-group">
                    <label>Name:</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Phone Number:</label>
                    <input
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Email Address:</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Select Slot:</label>
                    <select
                      value={selectedSlot}
                      onChange={(e) => setSelectedSlot(e.target.value)}
                      onClick={() => fetchSlots(bookingDate)}
                      required
                    >
                      <option value="">-- Choose a Slot --</option>

                      {slots
                        .filter((s) => s.id !== 3) // remove slot 3 entirely
                        .map((s) => {
                          const slot = SLOTS[s.id];
                          const full = s.remaining <= 0;
                          return (
                            <option key={s.id} value={s.id} disabled={full}>
                              {slot?.label} {full ? "(Full)" : ""}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Number of People:</label>
                    <input
                      type="number"
                      min="1"
                      value={numPeople}
                      onChange={(e) => setNumPeople(parseInt(e.target.value))}
                      required
                    />
                  </div>

                  {message && !bookingSuccess && (
                    <p className="error-message">{message}</p>
                  )}

                  <button type="submit" className="post-review-btn">
                    {loading ? "Submitting..." : "Submit Booking"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuffetBookingPage;
